import { Injectable } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { TextEditorHistoryService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-history.service';
import { ITextPanelButton } from '../simple-text-panel/text-panel-base';

@Injectable()
export class AdvancedTextPanelRemoveFormatService {
    constructor(
        private appTextService: AppTextService,
        private textEditorHistoryService: TextEditorHistoryService,
    ) {}

    getButtons(): ITextPanelButton[] {
        return [
            {
                title: this.appTextService.get('text_editor.remove_formatting'),
                class: 'fas fa-remove-format',
                btnClass: 'BrandedColorHover panel-icon-button',
                callback: () => {
                    this.textEditorHistoryService.saveState();
                    // remove formatting and convert all selected content to one text node
                    // because we need to remove all links, images, etc...
                    // in result there should be just plain text
                    document.execCommand('removeFormat');
                    const sel: Selection = window.getSelection();
                    const span: HTMLElement = document.createElement('span');
                    const range: Range = sel.getRangeAt(0);
                    range.surroundContents(span);
                    const newNode: Text = document.createTextNode(span.textContent);
                    range.deleteContents();
                    range.insertNode(newNode);
                    range.selectNode(newNode);
                },
            },
        ];
    }
}
